import React from 'react';
import { Field, Button } from '@ontruck/orc';
import FieldError from 'components/form/FieldError';
import Modal from 'components/layout/Modal';

const UserModal = ({
  className,
  onClose,
  handleFieldChange,
  handleSendInvitation,
  handleEdit,
  first_name,
  last_name,
  email,
  phone,
  errors,
  warnings,
  t,
  mode = 'INVITE',
}) => {
  const isInEditionMode = mode === 'EDIT';

  return (
    <Modal
      show
      title={isInEditionMode ? t('title-edition') : t('title')}
      size="S"
      onClose={onClose}
    >
      <form className={className} autoComplete="off">
        <div className="field-container">
          <Field
            type="text"
            name="first_name"
            id="first_name"
            label={t('first_name')}
            onChange={handleFieldChange}
            size="L"
            fullWidth
            invalid={!!warnings.first_name}
            error={!!errors.first_name}
            value={first_name}
          />
        </div>
        <div className="field-container">
          <Field
            type="text"
            name="last_name"
            id="last_name"
            label={t('last_name')}
            onChange={handleFieldChange}
            size="L"
            fullWidth
            invalid={!!warnings.last_name}
            error={!!errors.last_name}
            value={last_name}
          />
        </div>
        <div className="field-container">
          <Field
            type="email"
            name="email"
            id="email"
            label={t('email')}
            onChange={handleFieldChange}
            size="L"
            fullWidth
            invalid={!!warnings.email}
            error={!!errors.email}
            value={email}
            disabled={isInEditionMode}
          />
          {!!errors.email && (
            <FieldError className="error">
              {t('errors.invalid_email')}
            </FieldError>
          )}
        </div>
        <div className="field-container">
          <Field
            type="tel"
            name="phone"
            id="phone"
            label={`${t('phone')} (${t('optional')})`}
            onChange={handleFieldChange}
            size="L"
            fullWidth
            invalid={!!warnings.phone}
            error={!!errors.phone}
            value={phone}
          />
          {!!errors.phone && (
            <FieldError className="error">
              {t('errors.invalid_phone')}
            </FieldError>
          )}
        </div>

        <Button
          onClick={isInEditionMode ? handleEdit : handleSendInvitation}
          text={isInEditionMode ? t('edit') : t('send_invite')}
          fullWidth
        />
        <Button
          onClick={onClose}
          text={t('cancel')}
          fullWidth
          ghost
          skin="primary"
        />
      </form>
    </Modal>
  );
};

UserModal.defaultProps = {
  className: '',
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  errors: {},
  warnings: {},
  onClose: () => ({}),
  handleFieldChange: () => ({}),
  handleSendInvitation: () => ({}),
  t: (t) => t,
};

export default UserModal;
